<template>
    <div id="reservation-comment" class="popin-modal centered" v-show="isPopinDisplayed" v-observe-visibility="{ callback: popin_reservationCommentDisplayed_callback }">
        <div class="popin-container">
            <div class="popin-closure" v-on:click="popin_reservationCommentClosed">
                <div class="arrow">X</div>
            </div>
            <div class="popin-closure-responsive" v-on:click="popin_reservationCommentClosed">
                <div class="arrow">X</div>
            </div>
            <div class="popin">
                <div class="popin-content">
                    <div class="popin-content-container" v-if="reservation">
                        <p>Réservation au nom de {{ reservation.first_name }} {{ reservation.last_name }}</p>
                        <p>En date du {{ reservation.creneau_day }}/{{ reservation.creneau_month }}/{{ reservation.creneau_year }} pour {{ scenario.room_label }}</p>
                        <p>
                            <span>Commentaire</span>
                            <textarea maxlength="255" v-model="formReservationComment_comment" v-bind:disabled="request_isProcessing"></textarea>    
                        </p>
                        <div class="form-submit">
                            <span class="form-error">{{ formReservationComment_error }}</span>
                            <button v-if="request_isProcessing">
                                <Loader_Mini />
                            </button>
                            <button v-else v-on:click="enregistrer_buttonClicked">Enregistrer</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';

import Loader_Mini from '../../javascripts/components/Loader_Mini.vue';

import anime from 'animejs/lib/anime.es';
import axios from 'axios';

export default {
    name: "ReservationComment",
    components: {
        Loader_Mini
    },
    data: () => ({
        // popin parameters
        isPopinDisplayed: false,
        // data
        request_isProcessing: false,
        reservation: null,
        scenario: null,
        formReservationComment_comment: null,
        formReservationComment_error: null
    }),
    methods: {
        enregistrer_buttonClicked: function() {
            this.request_isProcessing = true;
            this.formReservationComment_error = null;

            var self = this;
            axios.post('https://api.lockquest.fr/reservation/comment', {
                reservation_id: self.reservation.id,
                comment: self.formReservationComment_comment.length > 0 ? self.formReservationComment_comment : null,
            }, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Authorization': `Basic ` + localStorage.getItem('admin-token')
                }
            }).then((response) => {
                this.reservation.comment = this.formReservationComment_comment;
                this.popin_reservationCommentClosed();

                this.request_isProcessing = false;
            }).catch((error) => {
                this.request_isProcessing = false;
                self.formReservationComment_error = 'Une erreur est survenue, merci de contacter l\'administrateur.';
            });
        },
        popin_reservationCommentDisplayed: function(reservation, scenario) {
           this.reservation = reservation;
           this.scenario = scenario;

           this.formReservationComment_comment = this.reservation.comment;

           this.isPopinDisplayed = true;
        },
        popin_reservationCommentClosed: function() {
            var self = this;
            anime({
                targets: 'div#reservation-comment.popin-modal > div.popin-container',
                opacity: [1, 0],
                duration: 250,
                easing: 'linear',
                complete: function(anime) {
                    self.isPopinDisplayed = false;
                    self.formReservationComment_comment = null;
                    self.formReservationComment_error = null;
                    self.reservation = null;
                    self.scenario = null;
                }
            });
        },
        popin_reservationCommentDisplayed_callback(visible, entry) {
            if (!visible) {
                return;
            }

            var self = this;
            anime({
                targets: 'div#reservation-comment.popin-modal > div.popin-container',
                opacity: [0, 1],
                duration: 250,
                easing: 'linear'
            });
        }
    }
}
</script>